import { useMutation } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Button } from "@papier/ui/components/ui/button";
import { orpc } from "@/lib/orpc";

export const Route = createFileRoute("/mcp/sign-in")({
  component: McpSignIn,
  validateSearch: (search) => search,
});

function McpSignIn() {
  const navigate = useNavigate();
  const begin = useMutation(
    orpc.mcp.begin.mutationOptions({
      onSuccess: ({ requestId }) =>
        navigate({ to: "/mcp/authorize", search: { requestId }, replace: true }),
    }),
  );
  return (
    <main className="mx-auto w-full max-w-xl space-y-5 px-5 py-16">
      <h1 className="text-2xl font-semibold">Connect to Papier</h1>
      <p className="text-muted-foreground">
        Sign in to review which projects your MCP client can access. Nothing is shared until you
        approve.
      </p>
      {begin.isError && (
        <p role="alert" className="text-destructive">
          {begin.error.message}. Reconnect from your MCP client if the request expired.
        </p>
      )}
      <Button
        disabled={begin.isPending}
        isLoading={begin.isPending}
        onClick={() => begin.mutate({ oauthQuery: window.location.search.slice(1) })}
      >
        Continue to Papier
      </Button>
    </main>
  );
}
